// If you change any of the names here, make sure to update any templates that reference them
export enum DashboardType {
  none,
  AppsDashboard,
  AppDashboard,
  // plan,
  // environment,
  createApp,
  // advanced,
  // advancedWrite,
  CreateFunctionAutoDetectDashboard,
  CreateFunctionDashboard,
  CreateFunctionQuickstartDashboard,
  FunctionsDashboard,
  FunctionDashboard,
  FunctionIntegrateDashboard,
  FunctionManageDashboard,
  FunctionMonitorDashboard,
  CreateProxyDashboard,
  ProxiesDashboard,
  ProxyDashboard,
  SlotsDashboard,
  CreateSlotDashboard,
}



// WEBPACK FOOTER //
// ./src/app/tree-view/models/dashboard-type.ts